<template>
  <div class="mb-5">
    <v-card flat outlined :loading="isMainLoading || isLoading || isSaveing" min-height="30">
      <div v-if="!isLoading && market">
        <v-card class="mb-2" elevation="0">
          <v-card-title>{{ $t('bill.bill_detail') }}</v-card-title>
          <v-card-text>
            <v-row v-if="formBill.companyData">
              <v-col cols="12">
                <span>{{ $t('market.company_name') }}</span>
                <v-text-field v-model="formBill.companyData.name" flat background-color="grey lighten-4" solo
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12">
                <span>{{ $t('market.company_address') }}</span>
                <v-text-field v-model="formBill.companyData.address" flat background-color="grey lighten-4" solo
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12">
                <EditTaxId v-model='formBill.companyData.taxId' showLabel showWarning getIsVat getIsExport
                  :counter='false' hideDetails @onWriteData="onWriteData" :getLabel="$t('tax.tax_id_number_another_form')" />
              </v-col>
              <v-col cols="12">
                <span>{{ $t('address.company_branch') }}</span>
                <v-text-field v-model="formBill.companyData.branchName" flat background-color="grey lighten-4" solo
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="6">
                <span>{{ $t('market.company_tel') }}</span>
                <v-text-field v-model="formBill.companyData.tel" flat background-color="grey lighten-4" solo
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="6">
                <span>{{ $t('market.company_email') }}</span>
                <v-text-field v-model="formBill.companyData.email" flat background-color="grey lighten-4" solo
                  hide-details></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card class="mb-2" elevation="0">
          <v-card-title>{{ $t('market.format_due_date') }}</v-card-title>
          <v-card-text>
            <div class="flex due-date-box">
              <div class="text">{{ $t('market.payment_type') }}</div>
              <div style="width:350px;">
                <v-chip v-if="market.billingType == 1">{{ $t('market.payment_type_after') }}</v-chip>
                <v-chip v-else>{{ $t('market.payment_type_before') }}</v-chip>
              </div>
            </div>
            <div class="flex due-date-box">
              <div class="text">{{ $t('market.due_date_after_bill') }}</div>
              <div class="days">
                <v-currency-field :label="$t('duration_day')" :placeholder="$t('duration_day')"
                  v-model="formBill.creditTerm" outlined />
              </div>
              <div>
                <v-text-field disabled type="text" v-model="startDate" :label="$t('market.example_document_issue_date')"
                  :placeholder="$t('market.example_document_issue_date')" outlined></v-text-field>
              </div>
              <div>
                <v-text-field disabled type="text" :value="dateAddCreditTerm()"
                  :label="$t('market.example_document_due_date')" :placeholder="$t('market.example_document_due_date')"
                  outlined></v-text-field>
              </div>
            </div>
          </v-card-text>
        </v-card>
        <div class="flex gap-2">
          <v-card class="mb-2" elevation="0">
            <v-card-title>{{ $t('market.market_logo_and_company') }}</v-card-title>
            <v-card-text>
              <div style="padding:0 20px;max-width:600px;">
                <div class="img-box bg-gray-100">
                  <v-btn v-if="formBill.companyData.logo" icon large class="close-icon"
                    @click="formBill.companyData.logo = null" :disabled="imageUpLoading">
                    <v-icon color="error">mdi-close</v-icon>
                  </v-btn>
                  <img v-if="!imageUpLoading && formBill.companyData.logo" :src="formBill.companyData.logo.url"
                    @load="loadImage" @error="errorImg" class="img-logo" alt="logo" id="logo-def" />
                  <div class="img-load" v-if="imageUpLoading || (formBill.companyData.logo && imageLoading)">
                    <v-progress-circular :size="70" :width="7" color="success" indeterminate
                      class="center"></v-progress-circular>
                  </div>
                </div>
                <v-file-input :disabled="imageUpLoading"
                  @change="uploadImage($event, formBill.companyData.logo, 'logo')" v-model="formBill.companyData.logo"
                  outlined accept="image/png, image/jpeg, image/bmp" :placeholder="$t('market.select_market_logo')"
                  prepend-icon="mdi-camera" :label="$t('market.market_image_logo')"></v-file-input>
                <span>{{ $t('market.market_image_logo_size') }}</span>
                <div>
                  <span>{{ $t('market.market_image_logo_size_description') }}</span>
                </div>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="mb-2" elevation="0">
            <v-card-title>{{ $t('market.thermalprinter_logo') }}</v-card-title>
            <v-card-text class="logo-pos">
              <div>
                <div class="img-box bg-gray-100">
                  <v-btn v-if="formBill.companyData.logo_pos" icon large class="close-icon"
                    @click="formBill.companyData.logo_pos = null" :disabled="imageUpLoading">
                    <v-icon color="error">mdi-close</v-icon>
                  </v-btn>
                  <img v-if="!imageUpLoading && formBill.companyData.logo_pos" :src="formBill.companyData.logo_pos.url"
                    @load="loadImage" @error="errorImg" class="img-logo" alt="logo-pos" id="logo-pos" />
                  <div class="img-load" v-if="imageUpLoading || (formBill.companyData.logo_pos && imageLoading)">
                    <v-progress-circular :size="70" :width="7" color="success" indeterminate
                      class="center"></v-progress-circular>
                  </div>
                </div>
                <v-file-input :disabled="imageUpLoading"
                  @change="uploadImage($event, formBill.companyData.logo_pos, 'logo_pos')"
                  v-model="formBill.companyData.logo_pos" outlined accept="image/png, image/jpeg, image/bmp"
                  :placeholder="$t('market.select_thermalprinter_logo')" prepend-icon="mdi-camera"
                  :label="$t('market.thermalprinter_image_logo')">
                </v-file-input>
                <span>{{ $t('market.thermalprinter_image_logo_size') }}</span>
                <div>
                  <span>{{ $t('market.thermalprinter_image_logo_size_description') }}</span>
                </div>
              </div>
              <div class="logo-pos-draft">
                <div><v-icon>mdi-brush-variant</v-icon>{{ $t('market.thermalprinter_edit_logo') }}</div>
                <div class="img-box bg-gray-100">
                  <img v-if="!imageUpLoading && logo_pos_temp" :src="logo_pos_temp" @error="errorImg" class="img-logo"
                    alt="logo-pos-draf" />
                </div>
                <v-btn-toggle v-model="logo_pos_document" mandatory @change="changeImageLogoPOS(step)">
                  <v-btn value="logo-def" small>
                    {{ $t('market.market_logo_and_company') }}
                  </v-btn>
                  <v-btn value="logo-pos" small>
                    {{ $t('market.thermalprinter_logo') }}
                  </v-btn>
                </v-btn-toggle>
                <v-slider @change="changeImageLogoPOS($event)" v-model="step" :min="100" :max="700" label="B&W"
                  :disabled="!logo_pos_document" color="info">
                </v-slider>
                <v-btn color="info" outlined :disabled="!logo_pos_temp || !logo_pos_document || imageUpLoading"
                  @click="uploadImage(logo_pos_temp, formBill.companyData.logo_pos, 'logo_pos', true)">
                  {{ $t('market.use_as_thermalprinter_logo') }}
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </div>
        <v-card elevation="0" max-width="800">
          <v-card-title>{{ $t('market.document_topic') }}</v-card-title>
          <v-card-text class="ps-7">
            <v-row>
              <v-col cols="4" class="d-flex align-center" style="font-size: 18px;">{{ $t('invoice.title') }}</v-col>
              <v-col cols="8">
                <v-select :items="[
                  'ใบแจ้งหนี้ และ ใบแจ้งการชำระเงิน / Pay-in Slip', 'ใบแจ้งหนี้ / ใบกำกับภาษี', 'ใบแจ้งหนี้'
                ]" v-model="formBill.setting.invoiceTopic" outlined hide-details :no-data-text="$t('noinfo')">
                  <template v-slot:selection="{ item }">
                    {{ $t(`invoiceTopic.${item}`) }}
                  </template>
                  <template v-slot:item="{ item }">
                    {{ $t(`invoiceTopic.${item}`) }}
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card elevation="0">
          <v-card-title>{{ $t('invoice.electronic_signature') }}</v-card-title>
          <v-card-text class="flex">
            <div class="sign-box">
              <div class="text">
                {{ $t('invoice.footer') }}
                <b>
                  <u>{{ $t('invoice.title') }}</u>
                </b>
              </div>
              <div class="sign-box-detail">
                <v-checkbox class="mt-2" v-model="formBill.sign.invoice.isShow"
                  :label="$t('invoice.use_electronic_signature')"></v-checkbox>
                <div class="pt-2">{{ $t('invoice.signature_image') }}</div>
                <div>
                  <div class="img-box sign bg-gray-100">
                    <v-btn v-if="formBill.sign.invoice.image" icon large class="close-icon"
                      @click="formBill.sign.invoice.image = null"
                      :disabled="imageUpLoading || !formBill.sign.invoice.isShow">
                      <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
                    <img v-if="!imageUpLoading && formBill.sign.invoice.image" :src="formBill.sign.invoice.image.url"
                      @load="loadImage" @error="errorImg" class="img-logo" alt="logo" />
                    <div class="img-load" v-if="imageUpLoading || (formBill.sign.invoice.image && imageLoading)">
                      <v-progress-circular :size="70" :width="7" color="success" indeterminate
                        class="center"></v-progress-circular>
                    </div>
                  </div>
                  <v-file-input :disabled="imageUpLoading || !formBill.sign.invoice.isShow"
                    @change="uploadImage($event, formBill.sign.invoice.image, 'sign-image-invoice')"
                    v-model="formBill.sign.invoice.image" outlined accept="image/png, image/jpeg, image/bmp"
                    :placeholder="$t('invoice.select_signature_image')" prepend-icon="mdi-camera"
                    :label="$t('invoice.signature_picture')" hide-details></v-file-input>
                  <div>{{ $t('invoice.signature_image_size') }}</div>
                  <div>{{ $t('invoice.signature_image_size_description') }}</div>
                </div>
                <div class="py-2 pt-5">{{ $t('name_surname') }}</div>
                <div class="flex">
                  <v-text-field style="width:80%;" v-model="formBill.sign.invoice.user"
                    :placeholder="$t('name_surname')" outlined hide-details clear-icon="mdi-close-circle"
                    @click:clear="formBill.sign.invoice.user = null"
                    :disabled="isLoading || !formBill.sign.invoice.isShow"></v-text-field>
                  <v-text-field style="margin:0;" v-model="formBill.sign.invoice.text" type="text" outlined hide-details
                    :disabled="!formBill.sign.invoice.isShow"></v-text-field>
                </div>
              </div>
            </div>
            <div class="sign-box">
              <div class="text">
                {{ $t('invoice.footer') }}
                <b>
                  <u>{{ $t('invoice.receipt_and_tax_bill') }}</u>
                </b>
              </div>
              <div class="sign-box-detail">
                <v-checkbox class="mt-2" v-model="formBill.sign.receipt.isShow"
                  :label="$t('invoice.use_electronic_signature')"></v-checkbox>
                <div class="pt-2">{{ $t('invoice.signature_image') }}</div>
                <div>
                  <div class="img-box sign bg-gray-100">
                    <v-btn v-if="formBill.sign.receipt.image" icon large class="close-icon"
                      @click="formBill.sign.receipt.image = null"
                      :disabled="imageUpLoading || !formBill.sign.receipt.isShow">
                      <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
                    <img v-if="!imageUpLoading && formBill.sign.receipt.image" :src="formBill.sign.receipt.image.url"
                      @load="loadImage" @error="errorImg" class="img-logo" alt="logo" />
                    <div class="img-load" v-if="imageUpLoading || (formBill.sign.receipt.image && imageLoading)">
                      <v-progress-circular :size="70" :width="7" color="success" indeterminate
                        class="center"></v-progress-circular>
                    </div>
                  </div>
                  <v-file-input :disabled="imageUpLoading || !formBill.sign.receipt.isShow"
                    @change="uploadImage($event, formBill.sign.receipt.image, 'sign-image-receipt')"
                    v-model="formBill.sign.receipt.image" outlined accept="image/png, image/jpeg, image/bmp"
                    :placeholder="$t('invoice.select_signature_image')" prepend-icon="mdi-camera"
                    :label="$t('invoice.signature_picture')" hide-details></v-file-input>
                  <div>{{ $t('invoice.signature_image_size') }}</div>
                  <div>{{ $t('invoice.signature_image_size_description') }}</div>
                </div>
                <div class="py-2 pt-5">{{ $t('name_surname') }}</div>
                <div class="flex">
                  <v-text-field style="width:80%;" v-model="formBill.sign.receipt.user"
                    :placeholder="$t('name_surname')" outlined hide-details clear-icon="mdi-close-circle"
                    @click:clear="formBill.sign.receipt.user = null"
                    :disabled="isLoading || !formBill.sign.receipt.isShow"></v-text-field>
                  <v-text-field style="margin:0;" v-model="formBill.sign.receipt.text" type="text" outlined hide-details
                    :disabled="!formBill.sign.receipt.isShow"></v-text-field>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
        <v-card class="mb-0" elevation="0">
          <v-card-title>{{ $t('market.myket_app_setting') }}</v-card-title>
          <v-card-text>
            <v-checkbox class="mt-0" v-model="formBill.setting.enableTenantPrintReceipt" hide-details
              :label="$t('invoice.allow_tenant_print_receipt')">
            </v-checkbox>
            <v-checkbox class="mt-0" v-model="formBill.setting.enableSendInvoiceToEmail" hide-details
              :label="$t('invoice.send_invoice_to_email')">
            </v-checkbox>
          </v-card-text>
        </v-card>
        <v-card elevation="0">
          <v-card-title>
            {{ $t('invoice.invoice_footer_note') }}
            <b style="text-decoration: underline;" class="ms-2">{{ $t('invoice.title') }}</b>
          </v-card-title>
          <v-card-text>
            <v-textarea v-model="formBill.setting.invoiceNote" flat background-color="grey lighten-4" hide-details
              solo></v-textarea>
          </v-card-text>
        </v-card>
        <v-card elevation="0">
          <v-card-title>
            {{ $t('invoice.invoice_footer_note') }}
            <b style="text-decoration: underline;" class="ms-2">{{ $t('invoice.receipt_and_tax_bill') }}</b>
          </v-card-title>
          <v-card-text>
            <v-textarea v-model="formBill.setting.receiptNote" flat background-color="grey lighten-4" hide-details
              solo></v-textarea>
          </v-card-text>
        </v-card>
        <v-card elevation="0">
          <v-card-title>
            {{ $t('invoice.invoice_footer_note') }}
            <b style="text-decoration: underline;" class="ms-2">{{ $t('bill.quotation') }}</b>
          </v-card-title>
          <v-card-text>
            <v-textarea v-model="formBill.setting.quotationNote" flat background-color="grey lighten-4" hide-details
              solo></v-textarea>
          </v-card-text>
        </v-card>
      </div>
      <div v-if="!isLoading && !market" class="text-center p-10">{{ $t('market.no_market_data') }}</div>
      <v-card-actions v-else-if="!isLoading && market" class="flex sticky-bottom">
        <v-btn large :disabled="isLoading || isSaveing" :loading="isSaveing" color="success"
          @click="saveMarketBill()">{{
            $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EditTaxId from "@/components/EditTaxId.vue";
import TH from "@/plugins/vue-i18n/locales/th-TH.json";
import LO from "@/plugins/vue-i18n/locales/lo-LA.json";
import {
  Market,
  MarketSetting,
  FileUpload,
} from "../../classes";
export default {
  props: {
    isMainLoading: Boolean
  },
  components: {
    EditTaxId
  },
  computed: {
    ...mapGetters({
      // accountingProducts: "accountingProducts/getAccountingProductPenalty"
    }),
  },
  data() {
    return {
      rules: {
        required: value => !!value || this.$t('validate.please_select_list'),
        maxPercent: v => v <= 100 || this.$t('validate.please_max_percent'),
        minPercent: v => v > 0 || this.$t('validate.please_min_percent'),
        minCost: v => v > 0 || this.$t('validate.please_min_cost', { currencySign: this.$helper.currencySign() })
      },
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      market: null,
      isSaveing: false,
      isLoading: false,
      imageUpLoading: false,
      imageLoading: false,
      imgUpload: null,
      startDate: this.$moment().format("DD/MM/YYYY"),
      formBill: {
        creditTerm: null,
        companyData: {
          name: "",
          address: "",
          taxId: "",
          branchName: "",
          tel: "",
          email: "",
          logo: null,
          logo_pos: null,
        },
        setting: {
          marketId: "",
          id: "",
          invoiceNote: "",
          receiptNote: "",
          quotationNote: "",
          enableTenantPrintReceipt: false,
          enableSendInvoiceToEmail: false,
          invoiceTopic: "ใบแจ้งหนี้ และ ใบแจ้งการชำระเงิน / Pay-in Slip"
        },
        sign: {
          invoice: {
            isShow: false,
            showDate: false,
            isWrap: false,
            text: this.$globalLocale == "la" ? LO.messages.invoice.invoice_bill_user : TH.messages.invoice.invoice_bill_user,
            user: null,
            image: null
          },
          receipt: {
            isShow: false,
            showDate: false,
            isWrap: false,
            text: this.$globalLocale == "la" ? LO.messages.task.approve_bill_user : TH.messages.task.approve_bill_user,
            user: null,
            image: null
          }
        }
      },
      step: 400,
      logo_pos_document: null,
      logo_pos_temp: null,
    };
  },
  mounted() {
    this.initData();

  },
  methods: {
    async initData() {
      this.market = null;
      this.isLoading = true;
      try {
        this.market = await Market.getMarket(this.marketId);
        if (this.market) {
          if (this.market.companyData) {
            let {
              name,
              address,
              taxId,
              branchName,
              tel,
              email,
              logo,
              logo_pos
            } = this.market.companyData;
            this.formBill.companyData.name = name || "";
            this.formBill.companyData.address = address || "";
            this.formBill.companyData.taxId = taxId || "";
            this.formBill.companyData.branchName = branchName || "";
            this.formBill.companyData.tel = tel || "";
            this.formBill.companyData.email = email || "";
            if (logo) {
              this.imageLoading = true;
              this.formBill.companyData.logo = logo;
              this.logo_pos_document = "logo-def"
            }
            if (logo_pos) {
              this.imageLoading = true;
              this.formBill.companyData.logo_pos = logo_pos;
              this.logo_pos_document = "logo-pos"
            }
          }
          if (this.market.setting) {
            let { objectId, invoiceNote, receiptNote, quotationNote, enableTenantPrintReceipt, enableSendInvoiceToEmail, invoiceTopic } = this.market.setting;
            this.formBill.setting.marketId = this.market.objectId || "";
            this.formBill.setting.id = objectId || "";
            this.formBill.setting.invoiceNote = invoiceNote || "";
            this.formBill.setting.receiptNote = receiptNote || "";
            this.formBill.setting.quotationNote = quotationNote || "";
            this.formBill.setting.invoiceTopic = invoiceTopic || "ใบแจ้งหนี้ และ ใบแจ้งการชำระเงิน / Pay-in Slip";
            this.formBill.setting.enableTenantPrintReceipt = enableTenantPrintReceipt || false;
            this.formBill.setting.enableSendInvoiceToEmail = enableSendInvoiceToEmail || false;
            if (this.market.setting.sign) {
              this.formBill.sign = this.market.setting.sign;
            }
          } else {
            this.formBill.setting.marketId = this.marketId || "";
          }
          this.formBill.creditTerm = this.market.creditTerm || 7
        }
        this.isLoading = false;
      } catch (error) {
        this.$toast.show({
          content: this.$t('error_and_message', { error: error.message }),
          color: "error"
        });
        this.isLoading = false;
      }
    },
    async getAccountingProducts() {
      await this.$store.dispatch(
        "accountingProducts/getAccountingProducts",
        this.projectId
      );
    },
    async saveMarketBill() {
      this.isSaveing = true;
      try {
        if (this.formBill) {
          let marketSettingId;
          if (this.formBill.setting.id) {
            let setting = await MarketSetting.updateMarketSetting({
              ...this.formBill.setting,
              sign: this.formBill.sign
            });
            marketSettingId = setting.objectId;
          } else {
            let setting = await MarketSetting.createMarketSetting({
              ...this.formBill.setting,
              sign: this.formBill.sign
            });
            marketSettingId = setting.objectId;
            this.formBill.setting.id = setting.objectId;
          }
          await Market.updateMarket({
            id: this.market.objectId,
            companyData: this.formBill.companyData,
            penalty: this.market.penalty ? this.market.penalty : undefined,
            creditTerm: parseFloat(this.formBill.creditTerm),
            marketSettingId
            // sign: this.formBill.sign
          });
        }
        this.isSaveing = false;
        this.$toast.show({
          content: this.$t('save_success'),
          color: "success"
        });
      } catch (error) {
        this.$toast.show({
          content: this.$t('error_and_message', { error: error.message }),
          color: "error"
        });
        this.isSaveing = false;
      }
    },
    async uploadImage(e, to, key, isBase64 = false) {
      try {
        to = null;
        if ((e && e.size <= 2000000) || (e && isBase64)) {
          this.$toast.show({
            color: "warning",
            content: this.$t('upload.uploading_image')
          });
          this.imageUpLoading = true;
          const file = await FileUpload.upload(e, '', isBase64);
          this.imageUpLoading = false;
          this.imageLoading = true;
          to = file;
          if (key == "logo") {
            this.formBill.companyData.logo = file;
            if (!this.formBill.companyData.logo_pos)
              this.logo_pos_document = "logo-def"
          } else if (key == "logo_pos") {
            this.formBill.companyData.logo_pos = file;
            this.logo_pos_document = "logo-pos"
          } else if (key == "sign-image-invoice") {
            this.formBill.sign.invoice.image = file;
          } else if (key == "sign-image-receipt") {
            this.formBill.sign.receipt.image = file;
          }
          this.$toast.show({
            color: "success",
            content: this.$t('upload.upload_image_success')
          });
        } else if (e && e.size > 2000000) {
          this.$toast.show({
            color: "error",
            content: this.$t('upload.image_size_error')
          });
        } else {
          this.$toast.show({
            color: "error",
            content: this.$t('upload.image_format_error')
          });
        }
      } catch (e) {
        this.$toast.show({
          color: "error",
          content: this.$t('upload.during_upload_image_error')
        });
        console.log(e);
      }
    },
    loadImage(e) {
      this.imageLoading = false;
      this.changeImageLogoPOS(this.step)
    },
    errorImg(e) {
      this.imageLoading = false;
      if (e?.target) e.target.src = "../../assets/images/error-img.png";
      else if (e?.srcElement)
        e.srcElement.src = "../../assets/images/error-img.png";
    },
    dateAddCreditTerm() {
      let text = "";
      if (this.formBill && this.formBill.creditTerm) {
        text = this.$moment()
          .add(this.formBill.creditTerm, "days")
          .format("DD/MM/YYYY");
      }
      return text;
    },
    changeImageLogoPOS(step) {
      let img = document.getElementById(this.logo_pos_document);
      if (!img) return
      let canvas = document.createElement('canvas');
      let ctx = canvas.getContext("2d");
      img.crossOrigin = "*";
      canvas.width = img.naturalWidth || 1;
      canvas.height = img.naturalHeight || 1;
      ctx.drawImage(img, 0, 0);
      let imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      for (let i = 0; i < imgData.data.length; i += 4) {
        let count = imgData.data[i] + imgData.data[i + 1] + imgData.data[i + 2];
        // 382.5 is center (min 0 , max 765) // <b >w
        let colour = 0;
        if (imgData.data[i + 3] < 128) count = 765
        if (count > step) colour = 255;
        imgData.data[i] = colour;
        imgData.data[i + 1] = colour;
        imgData.data[i + 2] = colour;
        imgData.data[i + 3] = 255;
      }
      ctx.putImageData(imgData, 0, 0);
      this.logo_pos_temp = canvas.toDataURL()
    },
    onWriteData(dataTax) {
      if (dataTax) {
        this.formBill.companyData.name = dataTax.companyName
        this.formBill.companyData.address = dataTax.fullAddress
        // this.$forceUpdate();
        // this.form.addressStreet = dataTax.addressStreet;
        // this.form.addressSubDistrict = dataTax.Thambol;
        // this.form.addressDistrict = dataTax.Amphur;
        // this.form.addressProvince = dataTax.Province;
        // this.form.addressZipcode = dataTax.PostCode;
      }
    }

  }
};
</script>

<style lang="scss" scoped>
.img-box {
  position: relative;
  width: 300px;
  height: 300px;
  object-fit: contain;
  border: 1px solid rgba(128, 128, 128, 0.2);
  border-radius: 5px;
  margin: 0 0 15px 30px;
  text-align: center;
}

.img-logo {
  width: 1400px;
  height: 300px;
  object-fit: contain;
}

.img-load {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.close-icon {
  position: absolute;
  right: 5px;
  top: 5px;
}

.img-box.sign {
  height: 150px;
  width: 400px;
  margin: 15px auto;

  .img-logo {
    height: 100%;
  }
}

.due-date-box {
  div {
    align-self: baseline;
    padding: 0 10px;
    font-size: 15px;
  }

  div.text {
    font-size: 18px;
  }

  div.text-p {
    font-size: 16px;
  }

  div.days {
    max-width: 200px;
  }
}

// .sign-box .v-select.v-text-field::v-deep input {
//   display: none;
// }
.sign-box {
  div {
    align-self: baseline;
    margin: 0 20px;
    font-size: 15px;
  }

  div.text {
    font-size: 18px;
  }

  div.text-p {
    font-size: 16px;
  }

  .sign-box-detail {
    padding: 10px;
    margin: 5px 10px;
    max-width: 500px;
    background: rgba(128, 128, 128, 0.06);
    border: 1px solid rgba(128, 128, 128, 0.247);
    border-radius: 5px;
  }
}

.sticky-bottom {
  background: rgba(255, 255, 255, 0.74);
  position: sticky;
  bottom: 0;
  border-top: 1px solid rgb(228, 228, 231);
  justify-content: center;
}

.logo-pos {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid rgba(128, 128, 128, 0.247);
  border-radius: 5px;
  padding: 20px;

  .logo-pos-draft {
    display: flex;
    flex-direction: column;
    margin-left: 30px;
    ;
    align-items: center;

    .v-input__slider {
      margin-top: 15px;
      width: 100%;
    }
  }
}
</style>